/** French Entrepreneurship Support Translations */
export const entrepreneurship = {
  entrepreneurship: {
    pageTitle: "Dimension Soutien à l'Entrepreneuriat",
    weightInFII: "poids dans le FII",
    heroSubtitle: "Permettre aux Jeunes de Créer des Emplois Durables et Construire la Richesse (18-40 ans)",
    quote: "1,7 trillion de dollars est le déficit mondial de financement pour les petites et moyennes entreprises. Pourtant, en Afrique subsaharienne, 28% des jeunes poursuivent activement l'entrepreneuriat—2,3x la moyenne mondiale. Le déficit n'est pas l'ambition. C'est l'accès.",
    fiiWeightDistribution: "Distribution du Poids FII",
    mentalHealth: "Santé Mentale",
    workforceLabel: "Main-d'œuvre",
    entrepreneurshipLabel: "Entrepreneuriat",
    understandOpportunity: "Comprendre l'opportunité",
    opportunityTitle: "L'Opportunité Entrepreneuriale en Chiffres",
    opportunitySubtitle: "Statistiques critiques façonnant l'entrepreneuriat des jeunes à l'échelle mondiale",
    opportunity: {
      stat1Label: "déficit mondial de financement des PME",
      stat2Label: "taux TEA des jeunes en Afrique subsaharienne (2,3x moyenne mondiale)",
      stat3Label: "aspiration entrepreneuriale moyenne mondiale",
      stat4Label: "financement VC pour les femmes entrepreneures",
      stat5Label: "total du financement VC pour les femmes mondialement",
      stat6Label: "nouvelles startups lancées annuellement",
      stat7Label: "taux d'échec des startups en 5 ans",
      stat8Label: "emplois créés par 1% d'augmentation de l'entrepreneuriat",
    },
    severity: {
      barrier: "Barrière",
      opportunity: "Opportunité",
      gap: "Écart",
    },
    coreProblem: "Le Problème Central",
    coreProblemDesc: "Ce n'est PAS un manque d'ambition. L'entrepreneuriat est le mécanisme principal de survie dans les économies avec un emploi traditionnel limité. En Afrique/MO, 52% des jeunes veulent créer des entreprises—ce n'est pas un luxe; c'est l'économie du futur. Les vraies barrières: Écart de capital (1,7T$ mondialement), Écart de compétences (planification d'affaires, littératie financière), Écart de confiance (les prêteurs ne font pas confiance aux jeunes entrepreneurs), Écart d'infrastructure (charge réglementaire, systèmes de paiement), et Écart de genre (les femmes font face à 2-3x plus de barrières).",
    fiiTitle: "Méthodologie FII Entrepreneuriat",
    fiiSubtitle: "Score Entrepreneuriat = 25% de l'Indice d'Impact Futur",
    subWeight: "sous-poids",
    globalAverage: "Moyenne mondiale",
    highest: "Plus élevé",
    lowest: "Plus bas",
    fii: {
      easeOfBusiness: "Facilité de Faire des Affaires",
      easeOfBusinessDef: "Environnement réglementaire, friction startup, enregistrement d'entreprise",
      easeHighest: "Singapour, Nouvelle-Zélande (90+)",
      easeLowest: "Venezuela, Somalie (40-)",
      accessFinancing: "Accès au Financement",
      accessFinancingDef: "Disponibilité du capital, accès au crédit, VC, financement ange",
      accessHighest: "États-Unis, Royaume-Uni (80%+ population)",
      accessLowest: "Afrique subsaharienne (10-20%)",
      tea: "Entrepreneuriat en Phase Initiale (TEA)",
      teaDef: "% de la population démarrant/gérant activement de nouvelles entreprises",
      teaHighest: "Afrique subsaharienne (28%)",
      teaLowest: "Europe (12%)",
      digitalInfra: "Infrastructure Numérique",
      digitalInfraDef: "Internet, systèmes de paiement, préparation e-commerce",
      digitalHighest: "Pays nordiques (95%)",
      digitalLowest: "Afrique subsaharienne (20-30%)",
    },
    regionalTitle: "Scores Régionaux d'Entrepreneuriat",
    regionalSubtitle: "Dimension FII Entrepreneuriat: Performance Régionale",
    regions: {
      europe: "Europe",
      asiaPacific: "Asie et le Pacifique",
      americas: "Amérique",
      africaMe: "Afrique et Moyen-Orient",
    },
    status: {
      strong: "Fort",
      growing: "En Croissance",
      mixed: "Mixte",
      emerging: "Émergent",
    },
    regional: {
      europeDrivers: "Soutien réglementaire, accès au capital, incubateurs",
      europeOpportunity: "Culture d'aversion au risque a besoin d'accélération de l'innovation",
      asiaPacificDrivers: "Écosystème licorne, soutien gouvernemental, hubs technologiques",
      asiaPacificOpportunity: "Villes de niveau 2/3 ont besoin d'accès au capital",
      americasDrivers: "Amérique du Nord forte (80+), culture d'innovation",
      americasOpportunity: "Amérique latine a besoin de démocratisation du capital",
      africaMeDrivers: "Plus haute aspiration (52%), saut numérique",
      africaMeOpportunity: "Fermeture du déficit de capital sévère, liaison MFI",
    },
    strength: "Force",
    challenge: "Opportunité",
    easeScore: "Score de Facilité",
    financingScore: "Financement",
    teaScore: "Taux TEA",
    digitalScore: "Numérique",
    keyFinding: "Constat Clé",
    keyFindingDesc: "Les scores d'entrepreneuriat ne varient que de 12 points (Europe 72 vs. Afrique/MO 60) — le PLUS PETIT écart FII. Pourtant, l'aspiration entrepreneuriale est LA PLUS ÉLEVÉE en Afrique/MO (52% vs. 35% mondial). Cela signifie que la capacité existe; seule l'infrastructure manque.",
    projectionTitle: "Projection 2024 vs 2040",
    financingTitle: "Le Déficit de Financement de 1,7 Trillion $",
    financingSubtitle: "D'où vient le déficit mondial de financement des PME et comment JCI peut aider à le combler",
    gapByRegion: "Déficit de Financement par Région",
    trillion: "Trillion",
    totalGap: "Déficit Total Mondial de Financement des PME",
    timeline: "Délai",
    impact: "Impact",
    financingGapTitle: "Le Déficit de Financement de 1,7 Trillion $",
    financingGapSubtitle: "D'où vient le déficit mondial de financement des PME",
    financingGap: {
      subSaharan: "Afrique Subsaharienne",
      subSaharanGap: "500B$+",
      subSaharanCause: "Pas d'infrastructure de crédit formelle, haute perception de risque",
      southAsia: "Asie du Sud",
      southAsiaGap: "400B$+",
      southAsiaCause: "Barrières réglementaires, dominance de l'économie informelle",
      southeastAsia: "Asie du Sud-Est",
      southeastAsiaGap: "200B$+",
      southeastAsiaCause: "Inconsistance réglementaire, concentration VC",
      latinAmerica: "Amérique Latine",
      latinAmericaGap: "300B$+",
      latinAmericaCause: "Volatilité économique, charge réglementaire",
      mena: "Moyen-Orient/Afrique du Nord",
      menaGap: "200B$+",
      menaCause: "Marchés de capitaux limités, discrimination de genre",
    },
    gapMeaning: "Ce Que 'Déficit de Financement' Signifie Vraiment",
    gapTypes: {
      awareness: "Écart de Sensibilisation",
      awarenessDef: "Les entrepreneurs ne savent pas que des sources de financement existent",
      access: "Écart d'Accès",
      accessDef: "Capital concentré géographiquement + démographiquement",
      skills: "Écart de Compétences",
      skillsDef: "Ne peuvent pas écrire de propositions ou projections financières",
      trust: "Écart de Confiance",
      trustDef: "Les prêteurs ne font pas confiance aux jeunes entrepreneurs",
      collateral: "Écart de Garantie",
      collateralDef: "Les jeunes pauvres n'ont pas d'actifs à gager",
      gender: "Écart de Genre",
      genderDef: "Les femmes font face à 2-3x plus de barrières institutionnelles",
    },
    landscapeTitle: "Paysage Mondial de l'Entrepreneuriat",
    landscapeSubtitle: "Métriques d'entrepreneuriat par région (GEM 2024-25)",
    teaRate: "Taux TEA",
    businessTypes: "Types d'Entreprises",
    financing: "Financement",
    successRate: "Taux de Réussite",
    landscape: {
      subSaharanTitle: "Afrique Subsaharienne",
      subSaharanTea: "28% TEA (PLUS ÉLEVÉ mondialement)",
      subSaharanTypes: "70% micro, 25% PME, 5% évolutives",
      subSaharanFinancing: "80% autofinancé/famille; 5% formel",
      subSaharanSuccess: "40% taux de survie",
      southeastAsiaTitle: "Asie du Sud-Est",
      southeastAsiaTea: "20% TEA (fort, en croissance)",
      southeastAsiaTypes: "40% numérique, 35% commerce, 25% manufacture",
      southeastAsiaFinancing: "50% bootstrap, 30% ange/VC",
      southeastAsiaSuccess: "55% taux de survie",
      latinAmericaTitle: "Amérique Latine",
      latinAmericaTea: "18% TEA (en croissance)",
      latinAmericaTypes: "60% micro, 30% PME, 10% évolutives",
      latinAmericaFinancing: "70% autofinancé, 20% famille",
      latinAmericaSuccess: "45% taux de survie",
      europeTitle: "Europe",
      europeTea: "12% TEA (mature, stable)",
      europeTypes: "20% micro, 30% PME, 50% évolutives",
      europeFinancing: "60% institutionnel, 40% autofinancé",
      europeSuccess: "65% taux de survie",
      northAmericaTitle: "Amérique du Nord",
      northAmericaTea: "15% TEA (mené par l'innovation)",
      northAmericaTypes: "10% micro, 20% PME, 70% évolutives",
      northAmericaFinancing: "50% VC/ange, 30% institutionnel",
      northAmericaSuccess: "70% taux de survie",
    },
    deepDiveTitle: "Analyses Régionales Approfondies",
    deepDiveSubtitle: "Analyse détaillée de l'entrepreneuriat par région JCI",
    strengths: "Forces",
    challenges: "Défis",
    jciOpportunity: "Opportunité JCI",
    deepDive: {
      europe: {
        strength1: "Infrastructure de classe mondiale (clarté réglementaire, systèmes numériques)",
        strength2: "Accès au capital: 80B€+ investis en 2024",
        strength3: "Écosystème startup mature: incubateurs, accélérateurs",
        challenge1: "Aversion au risque: échec stigmatisé",
        challenge2: "Fuite des cerveaux vers États-Unis/Asie",
        challenge3: "Concentration du capital à Londres, Berlin, Paris",
        opportunity: "Focus sur l'accélération de l'innovation, startups deep tech",
      },
      asiaPacific: {
        strength1: "Écosystème licorne: Chine 200+, Inde 80+",
        strength2: "Accélération gouvernementale: milliards investis",
        strength3: "Dividende démographique: 35% moins de 25 ans",
        challenge1: "Inégalité extrême: richesse dans villes niveau 1",
        challenge2: "Volatilité réglementaire",
        challenge3: "Barrières de genre: culturelles + institutionnelles",
        opportunity: "Initiative startups niveau 2/3, programmes femmes en tech",
      },
      americas: {
        strength1: "Plus grand marché VC (150B$+ investis en 2024)",
        strength2: "Culture d'innovation: Silicon Valley, NYC, Toronto",
        strength3: "Marchés divers: tech, biotech, fintech",
        challenge1: "Fossé Nord-Sud de 14 points",
        challenge2: "Charge réglementaire Amérique latine",
        challenge3: "Seulement 2% des startups LAC obtiennent du VC",
        opportunity: "Pont Nord-Sud pour mentorat, capacité LAC",
      },
      africaMe: {
        strength1: "Plus haute aspiration mondialement: 52% veulent entreprendre",
        strength2: "Population jeune: 60% moins de 25 ans",
        strength3: "Saut numérique: mobile-first (95%+ ont des téléphones)",
        challenge1: "Déficit de financement MASSIF: 80% autofinancé",
        challenge2: "Écarts de compétences: planification, comptabilité",
        challenge3: "Filles systématiquement exclues",
        opportunity: "Opportunité de 10T$: atteindre 5% de 1,2B jeunes → 6M emplois",
      },
    },
    outcomesTitle: "Résultats et Études de Cas",
    outcomesSubtitle: "Impact mesurable des programmes CYE et entrepreneuriat JCI",
    cases: {
      hongKongCountry: "Hong Kong",
      hongKongTitle: "JAPJAP Zero Waste Limited",
      hongKongOutcome: "Déchets alimentaires → protéine + compost utilisant technologie AI-IoT. Fondatrice femme, origine immigrée.",
      hongKongMetric: "100+ tonnes traitées",
      panamaCountry: "Panama",
      panamaTitle: "Integra Project Management",
      panamaOutcome: "Efficacité de la chaîne d'approvisionnement alimentaire pour l'Amérique latine. 30 nouveaux produits, 97% taux de qualité.",
      panamaMetric: "250 tonnes CO2 réduites",
      turkeyCountry: "Turquie",
      turkeyTitle: "Grinove Materials",
      turkeyOutcome: "Déchets agricoles → biomatériaux compostables. Scientifique femme devenue entrepreneure.",
      turkeyMetric: "Expansion européenne prévue",
    },
    actionsTitle: "Actions Recommandées pour JCI",
    actionsSubtitle: "Priorités stratégiques pour combler le déficit entrepreneurial",
    actions: {
      action1Title: "Mettre CYE à l'Échelle 10x",
      action1Desc: "Passer de 108 à 1 000 entrepreneurs/an, atteignant 5 000 d'ici 2030",
      action1Effort: "18-24 mois",
      action1Impact: "10x portée",
      action2Title: "Fonds Entrepreneuriat Féminin",
      action2Desc: "Créer un fonds de 100M$ pour fondatrices avec microfinance + mentorat",
      action2Effort: "18 mois",
      action2Impact: "50K femmes d'ici 2030",
      action3Title: "Partenariats MFI",
      action3Desc: "Formaliser partenariats avec 50 institutions de microfinance",
      action3Effort: "12 mois",
      action3Impact: "500K accès au crédit",
      action4Title: "Hubs d'Incubation JCI",
      action4Desc: "Construire 30 hubs d'incubation en Afrique/Asie/ALC",
      action4Effort: "24 mois",
      action4Impact: "10K accélérés",
      action5Title: "Marketplace Startup",
      action5Desc: "Créer plateforme numérique connectant entrepreneurs avec fournisseurs, clients, mentors",
      action5Effort: "9-12 mois",
      action5Impact: "100K+ connectés",
      action6Title: "Réseaux Régionaux JIB",
      action6Desc: "Établir réseaux de mentorat reliant 5 000+ mentors avec fondateurs",
      action6Effort: "12 mois",
      action6Impact: "5K+ mentors",
    },
    ctaTitle: "L'Entrepreneuriat Crée des Emplois",
    ctaDescription: "Quand l'emploi traditionnel est rare, l'entrepreneuriat devient le PRINCIPAL chemin vers l'opportunité. 1 entrepreneur crée 3-5 emplois. Si JCI met à l'échelle 10x d'ici 2030: 5M emplois créés, 500B$+ en valeur d'entreprise mondialement.",
    exploreFII: "Explorer FII",
    exploreWorkforce: "Explorer Main-d'œuvre",
    dataSources: { title: "Sources de Données" },
  },
} as const;

export type EntrepreneurshipTranslations = typeof entrepreneurship;
